import moment from 'moment';
import { DATE_FORMAT } from '@/constants/dates';

const Filters = {
    date: (value) => {
        return value ? moment(value).format(DATE_FORMAT) : "";
    }
};

export default Filters;